
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Base64MediaFile } from '@/types/media'
import MediaItem from '@/types/mediaItem'

@Component({
  components: { }
})

export default class IssueShowCommentMediaItem extends Vue {
  @Prop() file!: Base64MediaFile
  @Prop() fileIndex!:number

  showPreview = false

  preview (file: Base64MediaFile) : void {
    if (file.type === 'application/pdf') {
      this.downloadFile(file)
    } else {
      this.showPreview = true
    }
  }

  downloadFile (file: MediaItem): void {
    const link = document.createElement('a')
    link.href = file.url
    link.download = file.name || 'download'
    link.target = '_blank'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  deleteMediaItem () : void {
    this.$emit('deleteMediaItem', this.fileIndex)
  }
}
